module.exports = __webpack_public_path__ + "img/back.37431fb3.svg";